import React, { useState } from "react";
import { Row, Col, Input } from "reactstrap";

const DateRangePicker = ({
  className,
  nameForStartDate,
  nameForTillDate,
  register,
  formState,
  getValues,
  minStartDate,
  maxStartDate,
  minEndDate,
  maxEndDate,
  maxEndDateErrorMessage,
}) => {
  const[endDateValidCheck,setEndDateValidCheck] = useState(false)
  const[endDateWithinAllowedRange,setEndDateWithinAllowedRange] = useState(false)
  const validateEndDate = (value) => {
    const startDate = getValues && getValues()[nameForStartDate];
    const threeMonthsLater = new Date(startDate);
    threeMonthsLater.setMonth(threeMonthsLater.getMonth() + 12);
    const endDateUpperLimit = maxEndDate ? new Date(maxEndDate) : threeMonthsLater;

    if (!startDate || !value) {
      return true; // Let required validation handle empty dates
    }
    const isStartDateValid = new Date(value) >= new Date(startDate);
    const isEndDateInAllowedRange = new Date(value) >= new Date(startDate) && new Date(value) <= endDateUpperLimit;
    if(isStartDateValid){
      setEndDateValidCheck(isStartDateValid)
    }else{
      setEndDateValidCheck(false)
    }
    if(isEndDateInAllowedRange){
      setEndDateWithinAllowedRange(isEndDateInAllowedRange)
    }else{
      setEndDateWithinAllowedRange(false)
    }

    return startDate && value && new Date(value) >= new Date(startDate) && new Date(value) <= endDateUpperLimit;
  };

  const computedDefaultEndMax = getValues()[nameForStartDate]
    ? new Date(new Date(getValues()[nameForStartDate]).setMonth(new Date(getValues()[nameForStartDate]).getMonth() + 3)).toISOString().split('T')[0] > new Date().toISOString().split('T')[0]
      ? new Date().toISOString().split('T')[0]
      : new Date(getValues()[nameForStartDate]).setMonth(new Date(getValues()[nameForStartDate]).getMonth() + 3)
    : new Date().toISOString().split('T')[0];

  const resolvedStartMin = minStartDate;
  const resolvedStartMax = maxStartDate || new Date().toISOString().split('T')[0];
  const resolvedEndMin = getValues()[nameForStartDate] || minEndDate;
  const resolvedEndMax = maxEndDate || computedDefaultEndMax;

  return (
    <Row>
      <Col sm="6">
        <Input
          name={nameForStartDate}
          className={className}
          type="date"
          innerRef={register({ required: true })}
          min={resolvedStartMin}
          max={resolvedStartMax}
        />
        {formState?.errors[nameForStartDate] &&
        formState?.errors[nameForStartDate]?.type === "required" ? (
          <div>
            <span className="text-danger">{"Start Date is required"}</span>
          </div>
        ) : null}
      </Col>

      <Col sm="6">
        <Input
          name={nameForTillDate}
          className={className}
          type="date"
          innerRef={register({ required: true, validate: validateEndDate })}
          min={resolvedEndMin}
          max={resolvedEndMax}
        />
         {formState?.errors[nameForTillDate] &&
        formState?.errors[nameForTillDate]?.type === "required" ? (
          <div>
            <span className="text-danger">{"End Date is required"}</span>
          </div>
        ) : formState?.errors[nameForTillDate]?.type === "validate" ? (
          <div>
            {!endDateValidCheck && <span className="text-danger">{"End Date must be greater than Start Date"}</span>}
            {endDateValidCheck && !endDateWithinAllowedRange && <span className="text-danger">{maxEndDateErrorMessage || "End Date must be within 12 months of Start Date"}</span>}
          </div>
        ) : null}
      </Col>
    </Row>
  );
};

export default DateRangePicker;
